import React from 'react';

/**
 * Einfacher, zentrierter Modal-Dialog mit abdunkelndem Hintergrund.
 * Schliesst per Klick auf den Hintergrund oder den ✕-Button.
 *
 * @param {{ titel: string, onClose: () => void, children: React.ReactNode }} props
 */
export default function Modal({ titel, onClose, children }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-ink/40 p-4 py-10 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg rounded-2xl border border-line bg-paper p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-center justify-between">
          <h2 className="font-serif text-xl font-semibold text-ink">{titel}</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg px-2 py-1 text-ink-muted transition-colors hover:bg-ink/5 hover:text-ink"
            aria-label="Schließen"
          >
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
